import { Divider } from '@mui/material';
import React from 'react';
import { mdiPhone, mdiEmail } from '@mdi/js';
import './contact.css';
import Icon from '@mdi/react';

import JakeProfile from '../../img/jake.jpg';
import MelvinProfile from '../../img/melvin.jpg';
import RemyProfile from '../../img/remy.jpeg';

export default function Contact() {

  const contacts = [
    {
      name: "Siew Joe Kane (Jake)",
      contact: "(+60) 123081836",
      role: [{ roleName: "Project Lead" }, { roleName: "Web Developer and Maintainer" }],
      email: "joekanesiew@outlook.com",
      profile: JakeProfile
    },
    {
      name: "Hoh Chee Kin (Melvin)",
      contact: "(+60) 102324840",
      role: [{ roleName: "Project Lead" }, { roleName: "Treasurer" }],
      email: "j19029906@student.newinti.edu.my",
      profile: MelvinProfile
    },
    {
      name: "Muhammad Remy Bin Othman",
      contact: null,
      role: [{ roleName: "MPU3442 Subject Lecturer" }],
      email: "remy.othman@newinti.edu.my",
      profile: RemyProfile
    },
  ]

  return (
    <div className="w-75 mx-auto" id="contact">
      <Divider />
      <div className='card m-2'>
        <div className='card-body'>
          <h3 className="text-center">📞Contact Us</h3>
          <div className='d-flex contact-container'>
            {
              contacts.map(x => {
                return (
                  <div className="w-100 mb-5 justify-center" key={x.name}>
                    <div>
                      <img alt="" draggable="false" src={x.profile} className="profile-container" />
                    </div>
                    <strong>{x.name}</strong>
                    <div className='my-1'>
                      {
                        x.contact ?
                          <Icon className="me-2" path={mdiPhone} size={1} />
                          : null
                      }
                      <span>{x.contact ? x.contact : null}</span>
                    </div>
                    <div className='my-1'>
                      {
                        x.email ?
                          <Icon className="me-2" path={mdiEmail} size={1} />
                          : null
                      }
                      <span>{x.email ? x.email : null}</span>
                    </div>
                    <div>
                      {x.role.map((mRole, i) => {
                        return (
                          <span key={i} className="me-1 rounded p-1 text-white" style={{ backgroundColor: "#3498db" }}>
                            <strong>{mRole.roleName}</strong>
                          </span>
                        )
                      })}
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>
    </div>
  )
}
